(function () {
  'use strict';

  var announcementSelector = '#shopify-section-header > .top_header_cstm';
  var mobileHeaderSelector = '.mobile_nav_res.cust-mobile-nav';
  var resizeObserver;
  var observedHeader;
  var observedAnnouncement;
  var frameId;

  function syncMobileHeaderOffset() {
    frameId = null;

    var announcement = document.querySelector(announcementSelector);
    var mobileHeader = document.querySelector(mobileHeaderSelector);

    if (!mobileHeader || window.getComputedStyle(mobileHeader).display === 'none') {
      return;
    }

    var announcementHeight = announcement ? announcement.getBoundingClientRect().height : 0;
    var mobileHeaderHeight = mobileHeader.getBoundingClientRect().height;
    var mobileHeaderBottom = announcementHeight + mobileHeaderHeight;

    document.documentElement.style.setProperty('--qd-announcement-height', announcementHeight + 'px');
    document.documentElement.style.setProperty('--qd-mobile-nav-height', mobileHeaderHeight + 'px');
    document.documentElement.style.setProperty('--qd-mobile-header-bottom', mobileHeaderBottom + 'px');

    if (window.ResizeObserver && (observedHeader !== mobileHeader || observedAnnouncement !== announcement)) {
      if (resizeObserver) {
        resizeObserver.disconnect();
      }

      resizeObserver = new ResizeObserver(scheduleMobileHeaderOffsetSync);
      resizeObserver.observe(mobileHeader);
      if (announcement) {
        resizeObserver.observe(announcement);
      }
      observedHeader = mobileHeader;
      observedAnnouncement = announcement;
    }
  }

  function scheduleMobileHeaderOffsetSync() {
    if (frameId !== null) {
      window.cancelAnimationFrame(frameId);
    }

    frameId = window.requestAnimationFrame(syncMobileHeaderOffset);
  }

  function initializeMobileHeaderOffset() {
    syncMobileHeaderOffset();

    if (document.body && window.MutationObserver) {
      new MutationObserver(scheduleMobileHeaderOffsetSync).observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMobileHeaderOffset);
  } else {
    initializeMobileHeaderOffset();
  }

  window.addEventListener('load', scheduleMobileHeaderOffsetSync);
  window.addEventListener('resize', scheduleMobileHeaderOffsetSync);
  window.addEventListener('orientationchange', scheduleMobileHeaderOffsetSync);
  document.addEventListener('shopify:section:load', scheduleMobileHeaderOffsetSync);
}());
